module.exports = __webpack_public_path__ + "img/TC.bd17caf6.svg";